enum PaymentMethods {
  CryptoCurrency = 1,
  BankAccount,
  WiseAccount,
  Paypal
}
  export default PaymentMethods;
  